import React from 'react';
import styles from '../../assets/css/footer.module.css';


import { FaFacebookF, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";



import meucontador from "../../assets/imagens/svg/logotipo.svg"
import { Tooltip } from 'antd';
import { FiHeadphones } from 'react-icons/fi';

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.topSection}>
                {/* Logo e Contato */}
                <div className={styles.brandCol}>
                    <div className={styles.logoText}>
                        <figure >
                            <img src={meucontador} alt="Meu Contador Online" title="Meu Contador Online" width="200" height="58" loading="lazy" />
                        </figure>
                    </div>
                    <div className={styles.contactInfo}>
                        <a style={{ color: "#020202", textDecoration: "none" }} href="mailto:contato@meucontadoronline.com.br" target="_blank" title="Fale com o Meu Contador Online através do e-mail: contato@meucontadoronline.com.br"><p>contato@meucontadoronline.com.br</p></a>
                        <a style={{ color: "#020202", textDecoration: "none" }} href="tel:08000420627" target="_blank"><p>0800 042 0627</p></a>

                        <a style={{ color: "#020202", textDecoration: "none" }} href="https://www.google.com/maps/dir//meu+contador+online/@-23.6526679,-46.5722401,13z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x94ce42796cb716dd:0xb0a04ddb381cf1a5!2m2!1d-46.5372207!2d-23.6526718" target="_blank">
                            <p>R. das Figueiras, 474 - 8º Andar</p>
                            <p>B. Jardim, Santo André-SP, 09080-300</p>
                        </a>

                    </div>

                    <div className={styles.reviewSection}>
                        <a href='https://www.reclameaqui.com.br/empresa/meu-contador-online/' target="_blank" rel="nofollow noopener" aria-label="Ver avaliações no Reclame Aqui">
                            <div className={styles["medal-container"]}>
                                <img src={require("../../assets/imagens/svg/selo-reclame-aqui.svg").default} alt="Ícone de medalha" />
                            </div>
                        </a>

                        <a href="https://www.google.com/search?q=meu+contador+online&amp;oq=meu+contador+online&amp;gs_lcrp=EgZjaHJvbWUqBggAEEUYOzIGCAAQRRg7MgYIARBFGEAyBggCEEUYPDIGCAMQRRhBMgYIBBBFGEEyBggFEEUYQdIBCDE5OTVqMGoxqAIAsAIA&amp;sourceid=chrome&amp;ie=UTF-8&amp;sei=bOlCaPf2FcLU1sQPwvT5kAQ#lrd=0x94ce42796cb716dd:0xb0a04ddb381cf1a5,1" target="_blank" rel="nofollow noopener" class="hover:opacity-80 transition-opacity" aria-label="Ver avaliações no Google">
                            <div className={styles["medal-container"]}>
                                <img src={require("../../assets/imagens/svg/selo-google-review.svg").default} alt="Google Review" title="Google Review" width="123" height="62" class="h-12 w-auto" loading="lazy" />
                            </div>
                        </a>
                    </div>
                </div>

                {/* Links A Empresa */}
                <div className={styles.linksCol}>
                    <h4>A Empresa</h4>
                    <ul>
                        <li><a href="https://www.meucontadoronline.com.br/contabilidade-online/sobre-nos">Sobre nós</a></li>
                        <li><a href="https://www.meucontadoronline.com.br/trabalhe-conosco">Trabalhe conosco </a></li>
                        <li><a href="https://www.meucontadoronline.com.br/blog">Blog </a></li>
                        <li><a href="https://www.meucontadoronline.com.br/politica-de-privacidade">Política de Privacidade</a></li>
                        <li><a href="https://www.meucontadoronline.com.br/ouvidoria">Ouvidoria</a></li>
                    </ul>
                </div>

                {/* Links Contabilidade */}
                <div className={styles.linksCol}>
                    <h4>Contabilidade</h4>

                    <ul>
                        <li ><a href="https://www.meucontadoronline.com.br/contabilidade-online/contabilidade-online" >Contabilidade Online</a></li>
                        <li ><a href="https://www.meucontadoronline.com.br/contabilidade-online/abrir-empresa-online" >Abrir Empresa  </a></li>
                        <li ><a href="https://www.meucontadoronline.com.br/trocar-de-contabilidade" >Trocar de Contabilidade </a></li>
                        <li ><a href="https://www.meucontadoronline.com.br/transformar-mei-em-me" >Migrar MEI para ME </a></li>
                        <li ><a href="https://www.meucontadoronline.com.br/consulta-cnae" >Consulta CNAE </a></li>
                    </ul>

                </div>

                {/* Ações e Social */}
                <div className={styles.actionCol}>
                    <div className={styles.loginArea}>
                        <a href="https://portal.meucontadoronline.com.br/portal/#PortalLogin" target="_blank" className={styles.loginBtn}>Login</a>


                        <a className={styles.planosBtn} href="https://www.meucontadoronline.com.br/trocar-contabilidade#planos">
                            Planos
                        </a>

                    </div>
                    <div className={styles.socialArea}>
                        <h4>SIGA-NOS</h4>
                        <div className={styles.socialIcons}>
                            <a target="_blank" href="https://www.facebook.com/meucontadoronline" aria-label="Facebook do Meu Contador Online"><FaFacebookF /></a>
                            <a target="_blank" href="https://www.instagram.com/meucontadoronline" aria-label="Instagram do Meu Contador Online"><FaInstagram /></a>
                            <a target="_blank" href="https://www.youtube.com/meucontadoronline" aria-label="YouTube do Meu Contador Online"><FaYoutube /></a>
                            <a target="_blank" href="https://www.linkedin.com/company/meu-contador-online/?viewAsMember=true" aria-label="LinkedIn do Meu Contador Online"><FaLinkedinIn /></a>
                        </div>
                    </div>
                </div>
            </div>

            <hr className={styles.divider} />

            <div className={styles.bottomSection}>
                <div className={styles.ouvidoriaBox}>
                    <div style={{fontSize: 28, marginRight: 10, position: "relative", top: 3}}>
                        <Tooltip title="Ouvidoria Meu Contador Online">
                            <a href="https://www.meucontadoronline.com.br/assets/imagens/headset.svg" style={{ color: "#005691" }} aria-label="Ouvidoria">
                                <FiHeadphones />
                            </a>
                        </Tooltip>
                    </div>
                    <div className={styles.ouvidoriaText}>
                        <h5 title="Ligue para Ouvidoria 0800 600 6002">OUVIDORIA</h5>
                        <span>0800 600 6002</span>
                    </div>
                </div>
                <p className={styles.legalText}>
                    Conforme determinação legal, as atividades contábeis são prestadas unicamente pela empresa <strong>MEU CONTADOR CONTABILIDADE</strong> através de seus contadores. <strong>A MEU CONT ONLINE LTDA</strong> é a empresa que fornece soluções de software e serviços de apoio administrativo. <strong>"MEU CONTADOR ONLINE"</strong> utilizado neste site faz referência ora à <strong>MEU CONTADOR CONTABILIDADE LTDA</strong> ora à <strong>MEU CONT ONLINE LTDA</strong>, as quais atuam em parceria e atendem a todas as exigências legais. Conselho Regional de Contabilidade - <strong>2SP036436</strong>
                </p>
            </div>
        </footer>
    );
};

export default Footer;